import React, { useState } from "react";
import { Form, Button, Container } from "react-bootstrap";
import { toast } from "../../helpers/swal";
import { forgotPassword } from "../../api/user-service";  // ➔ Yeni API çağrısı

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await forgotPassword({ email });
      toast(response.data.message, "success");
    } catch (err) {
      const message = err.response ? err.response.data.message : err;
      toast(message, "error");
    }
  };

  return (
    <Container className="mt-5" style={{ maxWidth: "400px" }}>
      <h3>Forgot Password</h3>
      <p>Enter your email to reset your password.</p>
      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="formEmail">
          <Form.Control
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </Form.Group>
        <Button type="submit" className="mt-3">Send Reset Link</Button>
      </Form>
    </Container>
  );
};

export default ForgotPasswordPage;
